// Component input cho một ô câu hỏi trong ma trận

import React from 'react'
import { QuestionCell } from '../../types/exam-matrix'

interface QuestionCellInputProps {
  value: QuestionCell
  onChange: (cell: QuestionCell) => void
  disabled?: boolean
}

export const QuestionCellInput: React.FC<QuestionCellInputProps> = ({
  value,
  onChange,
  disabled = false
}) => {
  const handleChange = (newCount: number) => {
    const isValid = newCount <= value.soCauCoSan
    onChange({
      ...value,
      soCauYeuCau: newCount,
      isValid
    })
  }
  
  const hasError = value.soCauYeuCau > value.soCauCoSan
  const isEmpty = value.soCauCoSan === 0
  
  return (
    <div className="flex flex-col items-center">
      <input
        type="number"
        min={0}
        max={value.soCauCoSan}
        value={value.soCauYeuCau}
        onChange={(e) => handleChange(parseInt(e.target.value) || 0)}
        disabled={disabled || isEmpty}
        className={`
          w-16 px-2 py-1 text-center border rounded text-sm
          ${hasError ? 'border-red-500 bg-red-50 text-red-700' : 'border-gray-300'}
          ${isEmpty ? 'bg-gray-100 cursor-not-allowed text-gray-400' : ''}
          ${disabled ? 'bg-gray-100 cursor-not-allowed' : ''}
          focus:outline-none focus:ring-2 focus:ring-blue-500
        `}
      />
      <div className={`text-xs mt-1 ${hasError ? 'text-red-600 font-medium' : 'text-gray-500'}`}>
        {isEmpty ? (
          <span className="text-red-500">0</span>
        ) : (
          <span>/{value.soCauCoSan}</span>
        )}
      </div>
    </div>
  )
}

